import LArtwork from "@components/LArtwork";
import LBox from "@components/LBox";
import LIcon from "@components/LIcon";
import LPressable from "@components/LPressable";
import LText from "@components/LText";
import type { Song } from "@libs/wire";
import { moderateScale } from "@utils/scale";

type PlaylistSongSuggestionRowProps = {
  onAdd: (song: Song) => void;
  song: Song;
  surface?: "dark" | "light";
};

const PlaylistSongSuggestionRow = ({
  onAdd,
  song,
  surface = "dark",
}: PlaylistSongSuggestionRowProps) => {
  const isLight = surface === "light";
  const artistNames = [...new Set(song.artists.map((artist) => artist.name))];

  return (
    <LBox
      alignItems="center"
      flexDirection="row"
      gap="s3"
      py="s2"
      testID={`playlist-song-suggestion-${song.id}`}
    >
      <LArtwork
        borderRadius="m"
        imageSize="small"
        size={moderateScale(48)}
        url={song.albums.at(0)?.image}
      />
      <LBox flex={1} gap="s1">
        <LText
          color={isLight ? "black" : "textPrimary"}
          numberOfLines={1}
          variant="Body/B1/Medium"
        >
          {song.title}
        </LText>
        <LText
          color={isLight ? "blackTranslucent70" : "soundArtistText"}
          numberOfLines={1}
          variant="Body/B2/Medium"
        >
          {artistNames.join(", ")}
        </LText>
      </LBox>
      <LPressable
        accessibilityLabel={`Add ${song.title} to playlist`}
        onPress={() => onAdd(song)}
        sentryEventName="playlist_suggestion_add_song"
        testID={`playlist-suggestion-add-${song.id}`}
      >
        <LIcon name="plus_circle" size={36} />
      </LPressable>
    </LBox>
  );
};

export default PlaylistSongSuggestionRow;
